import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULTS = { ios_url: "https://apps.apple.com/", android_url: "https://play.google.com/store" };

export default function Footer() {
  const [links, setLinks] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/settings/app-links").then(r => setLinks(r.data)).catch(() => {});
  }, []);
  return (
    <footer className="mt-24 bg-[#0A192F] text-[#FDFBF7] relative grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-sm bg-[#FDFBF7] flex items-center justify-center text-[#002855] font-display text-xl leading-none">P</div>
            <div className="font-display text-xl">PMF Foundation</div>
          </div>
          <p className="mt-4 text-sm text-slate-300 leading-relaxed">
            The Foundation & Association connects Presidential Management Fellows past and present in service to the nation.
          </p>
        </div>
        <div>
          <div className="label-eyebrow text-slate-400">Program</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/history" className="hover:text-[#C5A059]">Our History</Link></li>
            <li><Link to="/store" className="hover:text-[#C5A059]">Merchandise</Link></li>
            <li><Link to="/founders" className="hover:text-[#C5A059]">Founders' Circle</Link></li>
            <li><Link to="/feed" className="hover:text-[#C5A059]">Members Feed</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-slate-400">Community</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/groups" className="hover:text-[#C5A059]">Groups</Link></li>
            <li><Link to="/messages" className="hover:text-[#C5A059]">Messages</Link></li>
            <li><Link to="/register" className="hover:text-[#C5A059]">Join the Association</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-slate-400">Contact</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            <li>1455 Pennsylvania Avenue, NW</li>
            <li>Suite 400</li>
            <li>Washington, DC 20004</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-10">
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <div className="label-eyebrow text-slate-400">Get the app</div>
            <div className="mt-1 text-sm text-slate-300">Carry the Association in your pocket.</div>
          </div>
          <div className="flex items-center gap-3">
            <a href={links.ios_url} target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store" data-testid="footer-appstore-link" className="inline-block transition-transform hover:scale-[1.03]">
              <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" className="h-11 w-auto" />
            </a>
            <a href={links.android_url} target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play" data-testid="footer-googleplay-link" className="inline-block transition-transform hover:scale-[1.03]">
              <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" className="h-[64px] w-auto -my-2" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-slate-400 flex flex-col md:flex-row gap-3 justify-between">
          <div>© {new Date().getFullYear()} Presidential Management Fellows Foundation & Association. An independent alumni organization.</div>
          <div>Honoring 48 years of public service.</div>
        </div>
      </div>
    </footer>
  );
}
